import { Link, useNavigate, useParams } from 'react-router-dom'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { Keyword } from '../../types'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Page from '../../components/Page'
import Header from '../../components/Header'
import { useDeleteKeyword, useKeyword, useUpdateKeyword } from '../../hooks/keywords'
import KeywordForm from '../../components/KeywordForm'

export default function KeyowordsEdit() {
  const { id } = useParams()
  const { data: keyword } = useKeyword(+id!)
  const deleteKeyword = useDeleteKeyword()
  const updateKeyword = useUpdateKeyword()
  const [modalRm, modalRmActions] = useModalTrigger<Keyword>()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/keywords">Keywords</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {keyword!.value.it}
            </li>
          </ol>
        </nav>
        <button
          className="btn  btn-danger"
          onClick={() => modalRmActions.open(keyword)}
        >
          <i className="bi bi-trash3-fill"></i> Elimina
        </button>
      </Header>

      <div className="py-3 overflow-y-auto flex-1">
        <KeywordForm
          keyword={keyword}
          save={(formKeyword) =>
            updateKeyword.mutateAsync(formKeyword).then(() =>
              toast.success('Keyword salvata con successo!', {
                position: 'bottom-right',
                theme: 'colored',
              })
            )
          }
        />
      </div>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare la keyword {modalRm.value.value.it} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btnoutline-primary"
          >
            Annulla
          </button>
          <button
            className="btn btn-danger"
            disabled={deleteKeyword.isLoading}
            onClick={async () => {
              await deleteKeyword.mutateAsync(modalRm.value!.id)
              navigate('/keywords')
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
    </Page>
  )
}
